/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ApproveIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="6.6,14 2,9.3 3.4,7.9 6.6,11.1 13.6,3 15,4.4"/>
  ]
  getViewBox = () => '0 0 16 16'
}
